import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import { useTranslation } from 'react-i18next';
import getTestId from '../../../../../../tests/utils/get-test-id';
import { ToolStatus } from '../../../../types/tool.types';
import ToolArgumentsSection from '../../shared/ToolArgumentsSection';
import ToolJsonResultSection from '../../shared/ToolJsonResultSection';
import { ToolContent } from '../../styles';
import GrantResultsCard from './GrantResultsCard';
import { getFundingExplorerUrl } from './parse';
const SearchGrantsToolRenderer = ({ model, expandedSections, setExpandedSections, }) => {
    const { t } = useTranslation();
    const fundingExplorerUrl = getFundingExplorerUrl(model.tool);
    return (_jsxs(ToolContent, Object.assign({}, getTestId('assistant-tool-content'), { children: [fundingExplorerUrl && (_jsx(Button, { onClick: () => {
                    if (fundingExplorerUrl) {
                        window.open(fundingExplorerUrl, '_blank');
                    }
                }, variant: "card-action", children: t('assistant|assistant_tool_search_grants_view_search') })), model.status !== ToolStatus.PENDING && model.app === 'admin' && (_jsxs(_Fragment, { children: [_jsx(ToolArgumentsSection, { tool: model.tool, expandedSections: expandedSections, setExpandedSections: setExpandedSections }), model.status === ToolStatus.FAILURE ? (_jsx(ToolJsonResultSection, { tool: model.tool, status: model.status, expandedSections: expandedSections, setExpandedSections: setExpandedSections })) : (_jsx(GrantResultsCard, { tool: model.tool }))] }))] })));
};
export default SearchGrantsToolRenderer;
